import React, {useState} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Tooltip } from 'reactstrap';


const LoginButton = (props) => {
  const { loginWithRedirect } = useAuth0();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <Button size="sm" color="secondary" onClick={() => loginWithRedirect()} {...props} id="loginBtn">
      <i className="fa fa-lock"/>
      <Tooltip placement="top" isOpen={tooltipOpen} target="loginBtn" toggle={toggle}>
        Habilitar funciones de administrador
      </Tooltip>
    </Button>
  );
};

export default LoginButton;